import React from "react";
import classNames from "classnames";

import { events } from "@planzone/events";
import { useMessage } from "@components/useMessage";
import { useAdjustCapacity } from "@planzone/view-models";
import { computeNaturalPeriodBounds } from "../../utils";
import { NumberInput } from "./numberInput";
import { Props } from "./types";
import styles from "./styles.scss";

function Cell(props: Props) {
  const { from, to } = computeNaturalPeriodBounds(
    props.period.from,
    props.granularity,
  );
  const { isRequestPending, isRequestFailure, adjustCapacity } =
    useAdjustCapacity(props.resourceId, from, to, props.granularity);
  const [capacity, setCapacity] = React.useState(props.period.capacity);

  React.useEffect(() => {
    setCapacity(props.period.capacity);
  }, [props.period.capacity]);

  useMessage(
    ({ type, data }) =>
      type === events.adjustCapacitySucceeded &&
      data.request.resourceId === props.resourceId &&
      data.request.from === from &&
      data.request.to === to &&
      data.request.granularity === props.granularity &&
      setCapacity(data.period.capacity),
  );

  return (
    <div
      className={classNames(styles.cell, {
        [styles.failed]: isRequestFailure,
      })}
    >
      {props.canEdit ? (
        <NumberInput
          nbr={capacity}
          isDisabled={isRequestPending}
          edit={(nbr) => setCapacity(nbr < 0 ? 0 : nbr)}
          submit={(value) =>
            !isRequestPending &&
            adjustCapacity({
              resourceId: props.resourceId,
              from,
              to,
              granularity: props.granularity,
              value,
            })
          }
        />
      ) : (
        <p className={styles.value}>{capacity.toLocaleString(props.locale)}</p>
      )}
    </div>
  );
}

export { Cell };
